import styled from 'styled-components'
import { calculateResponsiveSize } from 'helpers/calculateResponsiveSize'
import { mediaMax } from 'helpers/mediaQueries'

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  gap: ${calculateResponsiveSize(20)};
  padding-bottom: 0;
  ${mediaMax('mobile')} {
    gap: 20px;
    padding-bottom: 0px;
  }
`
